module.exports = __webpack_public_path__ + "img/perforaciones_3-4_2304.0eaca65d.jpg";